import { Subscription } from "rxjs";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";

import { SessionService } from "app/Services/session.service";
import { distinctUntilChanged, filter } from "rxjs/operators";
import { AppSettings } from "../../app-settings";
import { HttpClientService } from "../../Services/http-client.service";
import { CustomerIoService } from "../../Services/customer-io.service";
import { RudderStackService } from "../../Services/rudderstack.service";
import { EventService } from "../../Services/event.service";

declare global {
  interface Window {
    Appcues: any;
    AppcuesSettings: any;
  }
}

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, OnDestroy {
  userAppcuesSplashScreenFlagCustom = false;
  email: string;
  private currentRoute: string;
  userAppcuesSplashScreenFlagSubscriptionCustom: Subscription;
  title = "app works awesome!";

  constructor(
    private httpClientService: HttpClientService,
    private sessionService: SessionService,
    private router: Router,
    private customerIoService: CustomerIoService,
    private rudderStackService: RudderStackService,
    private eventService: EventService
  ) {
    router.events
      .pipe(
        distinctUntilChanged((previous: any, current: any) => {
          // Subscribe to any `NavigationEnd` events where the url has changed
          if (current instanceof NavigationEnd) {
            return previous.url === current.url;
          }
          return true;
        })
      )
      .subscribe((x: any) => {
        //analytics.page();
      });
  }


  fetchUser() {
    let headers = new HttpHeaders();
    this.httpClientService
      .get(AppSettings.restApiUrl + "/api/user/info", headers)
      .subscribe((data) => {
        //this.email = data.username;
        //initialize intercom with user data
        (window as any).Intercom("boot", {
          api_base: "https://api-iam.intercom.io",
          app_id: "m98ci7f1",
          name: data.firstName + " " + data.lastName, // Full name
          email: data.username, // the email for your user
          //created_at: user.createdAt, // Signup date as a Unix timestamp
        });
      });
  }
  ngOnInit() {
    // The admin side panel preview runs in an iframe with no LMS session: no user fetch
    // (a 401 would redirect the frame to login), no analytics, no redirects.
    if (window.location.pathname.replace(/\/+$/, '').endsWith('/side-panel-preview')) {
      return;
    }
    // Load Customer.io In-App snippet + identify from the login session.
    // No-op when the CDP key is absent (ship-dark safe). Does NOT fire the
    // initial page() — that is owned by the NavigationEnd subscription below
    // (Angular fires NavigationEnd on initial load), so page() is never doubled.
    this.customerIoService.init();
    // Load the RudderStack SDK. Same ship-dark contract as Customer.io above: a
    // complete no-op while AppSettings.rudderWriteKey is empty. Also does NOT fire
    // an initial page() — that is owned by the NavigationEnd subscription below.
    this.rudderStackService.init();
    this.fetchUser();
    this.redirectToURL();
    this.userAppcuesSplashScreenFlagSubscriptionCustom =
      this.sessionService.userAppcuesSplashScreenFlagCustom.subscribe(
        (data) => {
          this.userAppcuesSplashScreenFlagCustom = data;
        }
      );
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (window.Appcues) {
          window.Appcues.page();
        }
        // RudderStack page().
        this.eventService.pageView();
        // Customer.io SPA requirement: manual page() on each navigation
        // (this also covers the initial load's NavigationEnd).
        this.customerIoService.page();
      });
  }
  ngOnDestroy(): void {
    if (this.userAppcuesSplashScreenFlagSubscriptionCustom) {
      this.userAppcuesSplashScreenFlagSubscriptionCustom.unsubscribe();
    }
  }
  redirectToURL() {
    if (localStorage.getItem("blitzkriegRedirectUrl") != null) {
      //this.router.navigate([localStorage.getItem("blitzkriegRedirectUrl")]);
      let redirectURL = localStorage.getItem("blitzkriegRedirectUrl");
      localStorage.removeItem("blitzkriegRedirectUrl");
      window.location.href = redirectURL;
      //this.router.navigate(['/page/sentence_correction']);
    }
  }
  showExpertLogOffButton() {
    if (document.cookie.indexOf("adminUsername=") > -1) {
      return true;
    } else {
      return false;
    }
  }
  deleteCookie(name) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
  }
  logoffExpert() {
    this.deleteCookie("adminUsername");
    // Replaced legacy deleteCookie("_cio") relic with the proper Customer.io
    // identity clear (prevents identity bleed on shared devices).
    this.customerIoService.reset();
    this.rudderStackService.reset();
    // This IS the exit from an admin-driven session, so drop the marker that
    // keeps analytics suppressed - otherwise it outlives the session and the
    // admin's own browser stays dark on every e-gmat app.
    this.rudderStackService.endImpersonatedSession();
    this.deleteCookie("km_ai");
    window.location.href = "https://e-gmat.com";
  }
}
